import type { LabeledGraphicElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { generateId } from '@vedalib/editor/lib/utils/id'
import { SlateElementType, textToRtValue } from '@vedalib/rich-text'
import { useState } from 'react'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './LabeledGraphicElement'
import * as s from './LabeledGraphicElement.module.scss'
import type { LabeledGraphicDemoType, LabeledGraphicState } from './labeledGraphicTypes'

const DEMO_VALUE: LabeledGraphicElementValue = {
  image: null,
  type: 'image',
  overlay: null,
  items: [
    {
      value: generateId(),
      description: [
        ...textToRtValue(t('elements.labeledGraphic.value.title'), SlateElementType.heading4),
        ...textToRtValue(t('elements.labeledGraphic.value.description')),
      ],
      x: '25%',
      y: '25%',
      image: null,
      pointIcon: null,
      overlay: null,
    },
    {
      value: generateId(),
      description: [
        ...textToRtValue(t('elements.labeledGraphic.value.title'), SlateElementType.heading4),
        ...textToRtValue(t('elements.labeledGraphic.value.description')),
      ],
      x: '50%',
      y: '50%',
      image: null,
      pointIcon: null,
      overlay: null,
    },
    {
      value: generateId(),
      description: [
        ...textToRtValue(t('elements.labeledGraphic.value.title'), SlateElementType.heading4),
        ...textToRtValue(t('elements.labeledGraphic.value.description')),
      ],
      x: '75%',
      y: '75%',
      image: null,
      pointIcon: null,
      overlay: null,
    },
  ],
}

const LabeledGraphicDemo: LabeledGraphicDemoType = ({ styles, fonts, feedback }) => {
  const [state, setState] = useState<LabeledGraphicState | undefined>()

  const handleSetState = (value: LabeledGraphicState) => setState((prev) => ({ ...prev, ...value }))
  const rootStyles = {
    ...styles,
    root: {
      width: '100%',
      height: 500,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    image: {
      borderRadius: styles.image.borderRadius,
      padding: 200, // rude hack to make image bigger
    },
  }

  return (
    <DemoWrapper>
      <div className={s.demo} style={styles.image}>
        <Element
          element={{
            id: `${CONFIG_ELEMENTS.labeledGraphic.type}-demo`,
            type: CONFIG_ELEMENTS.labeledGraphic.type,
            value: DEMO_VALUE,
            style: {},
            font: {},
            feedback: {},
          }}
          feedback={feedback}
          font={fonts}
          mode={DEMO_MODE}
          setState={handleSetState}
          state={state}
          //@ts-expect-error TODO
          styles={rootStyles}
        />
      </div>
    </DemoWrapper>
  )
}

export default LabeledGraphicDemo
